import PropTypes from 'prop-types';
import { Box } from '@mui/material';

// Highlight colour per kind of word (callReviewModel.highlightRanges), from the theme palette.
const KIND_SX = {
  name: { bgcolor: 'info.lighter' },
  treatment: { bgcolor: 'secondary.lighter' },
  time: { bgcolor: 'warning.lighter' },
  phone: { bgcolor: 'success.lighter' },
  booking: { bgcolor: 'primary.lighter' },
};

// `text` from `start` to `end` with `ranges` (sorted, non-overlapping) marked.
export default function HighlightedText({ text, ranges, start, end }) {
  const to = end ?? text.length;
  const pieces = [];
  let cursor = start;
  ranges.forEach((range) => {
    if (range.end <= cursor || range.start >= to) return;
    const from = Math.max(cursor, range.start);
    const until = Math.min(to, range.end);
    if (from > cursor) pieces.push(text.slice(cursor, from));
    pieces.push(
      <Box component="mark" key={from} data-kind={range.kind} sx={{ ...KIND_SX[range.kind], color: 'text.primary', borderRadius: 0.5, px: 0.25 }}>
        {text.slice(from, until)}
      </Box>
    );
    cursor = until;
  });
  if (cursor < to) pieces.push(text.slice(cursor, to));
  return pieces;
}

HighlightedText.propTypes = {
  text: PropTypes.string.isRequired,
  ranges: PropTypes.arrayOf(PropTypes.shape({ start: PropTypes.number, end: PropTypes.number, kind: PropTypes.string })),
  start: PropTypes.number,
  end: PropTypes.number,
};
HighlightedText.defaultProps = { ranges: [], start: 0, end: undefined };
